import {Component, OnInit} from '@angular/core';
import {AbstractProfileValidator} from "@biletix/features/performance/components/performance-page/ticket-content-viewport/ticket-selection-content/ticket-profile-validation/base/abstract-profile-validator";
import {FormBuilder, FormGroup} from "@angular/forms";
import {FieldConfig} from "@biletix/core/models/base/field-config.model";

@Component({
    standalone: false,
    selector: 'btx-token-profile-validator',
    templateUrl: './token-profile-validator.component.html',
    styleUrls: ['./token-profile-validator.component.scss']
})
export class TokenProfileValidatorComponent extends AbstractProfileValidator implements OnInit {

    tokenValidationForm!: FormGroup;

    fieldConfig: FieldConfig | any;

    isDiscountApplied: boolean = false;

    constructor(fb: FormBuilder) {
        super(fb);
    }

    ngOnInit(): void {

        //
        this.fieldConfig = this.validationFieldConfigs[0];
        this.initializeTokenForm();

    }

    initializeTokenForm() {
        this.tokenValidationForm = this.addValidationFieldItems([this.fieldConfig])!;
    }


    onValidateProfile() {
        if (this.tokenValidationForm.invalid || this.isDiscountApplied) {
            this.tokenValidationForm.markAllAsTouched();
            return;
        }

        //TODO: Token validate
        let formValue = this.tokenValidationForm.value;

    }

}
